import "./index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";

import AppShell from "../../components/appShell";
import ViewPlayers from "../../components/viewPlayers";
import { Pill } from "../../components/atoms";
import {
  activeBlock as activeBlockk,
  BiddingBlocks,
  getActiveSession,
  selectactiveBlock,
  selectbiddingBlocks,
  selectinfo,
  selectisLoggedIn,
  selectActiveSession,
  startBlock,
} from "../../store/features/curatorSlice";

const PlayerList = ({ socket }) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let [key, setKey] = useState("elite");
  let isLoggedin = useSelector(selectisLoggedIn);
  let activeBlock = useSelector(selectactiveBlock);
  let biddingBlocks = useSelector(selectbiddingBlocks);
  let info = useSelector(selectinfo);
  let session = useSelector(selectActiveSession);

  useEffect(() => {
    dispatch(activeBlockk());
    dispatch(BiddingBlocks());
    dispatch(getActiveSession());
  }, [isLoggedin]);

  const OnStartBlock = async () => {
    if (session?.sessionId) {
      let res = await dispatch(startBlock(key));
      if (res?.payload?.statusCode === 200) {
        socket.emit("start-block", {
          ...biddingBlocks[key][0],
          sessionId: session?.sessionId,
        });
        socket.on("block-started-curator", () => {
          navigate("/curator/auction");
        });
      }
    }
  };

  useEffect(() => {
    if (info._id) {
      socket.emit("curator-entry", info._id);
    }
  }, [info._id]);

  if (!isLoggedin) {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/curator/login">Sign in as a curator</Link> to open the
          player list.
        </p>
      </AppShell>
    );
  }

  const status = biddingBlocks?.[key]?.[0]?.status?.toLowerCase();

  return (
    <AppShell role="curator">
      {activeBlock?._id && session?.sessionId && (
        <Navigate to="/curator/auction" replace />
      )}

      <div className="player-list">
        <header className="player-list-head">
          <div>
            <h1 className="au-heading">Player List</h1>
            <p className="au-subheading">
              Every player in the pool, by category. Start a category to take it
              into the auction room.
            </p>
          </div>

          {session?.sessionId ? (
            <div className="player-list-actions">
              {status === "ready" && (
                <button
                  type="button"
                  className="au-btn primary"
                  onClick={OnStartBlock}
                >
                  Start category
                </button>
              )}
              {status === "stopped" && (
                <button
                  type="button"
                  className="au-btn primary"
                  onClick={OnStartBlock}
                >
                  Resume category
                </button>
              )}
              {status === "finished" && (
                <Pill tone="success">Category finished</Pill>
              )}
            </div>
          ) : (
            <p className="player-list-wait">
              Waiting for the admin to start the auction.
            </p>
          )}
        </header>

        <ViewPlayers blocks={biddingBlocks} keyState={{ key, setKey }} />
      </div>
    </AppShell>
  );
};

export default PlayerList;
